import React from 'react';
import './QuoteCard.css';

const QuoteCard = ({disc, title, content}) => {
	return (
		<div className="QuoteCard">
			<div className="QuoteCard-disc">{disc}</div>
			{title ? <h3 className>{title}</h3> : undefined}
			<div className="QuoteCard-content">{content}</div>
		</div>
	);
};

export default QuoteCard;



// WEBPACK FOOTER //
// ./src/widgets/QuoteCard.js